import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vt-header-validation-messages',
  templateUrl: './header-validation-messages.component.html',
  styleUrls: ['./header-validation-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderValidationMessagesComponent {
  @Input() messages: string[];
}
